import { AuthorizeRequest } from '@/define/commandSet/dji';

const commandGroups = [
  {
    name: 'Authorize',
    commands: [AuthorizeRequest],
  },
];

export default commandGroups;
